// gloss
export const ACCEPTED_IMAGE_MIME_TYPES = [
  'image/jpeg',
  'image/png',
  'image/gif',
  'image/webp',
] as const;

export type AcceptedImageMimeType = (typeof ACCEPTED_IMAGE_MIME_TYPES)[number];

export const isAcceptedImageMimeType = (fileType: string | undefined | null): boolean =>
  typeof fileType === 'string' && (ACCEPTED_IMAGE_MIME_TYPES as readonly string[]).includes(fileType);

export const buildUnsupportedImageMessage = (fileType: string | undefined | null): string => {
  const typeLabel = fileType && fileType.length > 0 ? fileType : 'this file';
  return `${typeLabel} isn't supported. Please use a JPEG, PNG, GIF, or WebP image (convert HEIC/iPhone photos to JPEG first).`;
};

export const buildProfileImageUploadErrorMessage = (err: unknown): string => {
  const message =
    err != null && typeof err === 'object' && 'message' in err && typeof (err as { message: unknown }).message === 'string'
      ? (err as { message: string }).message
      : '';
  return message ? `Failed to update profile image: ${message}` : 'Failed to update profile image';
};
